import React from 'react';
import { Grid, Container, useMediaQuery, TAGTypography, TAGLink } from '../../../..';
import { MOTTO_COLOR } from '../../../../constants/constant';

var MottoSchedulingFooter = function MottoSchedulingFooter(props) {
  var contentfulData = props.contentfulData;
  var data = contentfulData.footer;
  var navigationGroups = data.navigationGroups;
  var copyright = data.copyright;
  var aboutDataParsed = JSON.parse(data.about.raw);
  var aboutDataContent = aboutDataParsed.content;
  var isMediumDevice = useMediaQuery('(min-width: 768px)');
  var localDirection = isMediumDevice ? 'row' : 'column';

  var footerText = function footerText(content) {
    var _contentFields$, _contentFields$2, _contentFields$3;

    var contentFields = content.content.map(function (subContent) {
      return subContent;
    });
    var elm1 = ((_contentFields$ = contentFields[0]) === null || _contentFields$ === void 0 ? void 0 : _contentFields$.nodeType) === 'text' ? contentFields[0].value : '';
    var elm2 = ((_contentFields$2 = contentFields[1]) === null || _contentFields$2 === void 0 ? void 0 : _contentFields$2.nodeType) === 'hyperlink' ? contentFields[1] : '';
    var elm3 = ((_contentFields$3 = contentFields[2]) === null || _contentFields$3 === void 0 ? void 0 : _contentFields$3.nodeType) === 'text' ? contentFields[2].value : '';
    return React.createElement(TAGTypography, {
      color: "text.light",
      variant: "bodySmallBook"
    }, elm1, ' ', elm2 && React.createElement(TAGLink, {
      href: elm2.data.uri,
      variant: "bodySmallBook",
      key: elm2.data.uri,
      color: "neutrals.white",
      sx: {
        display: 'inline'
      }
    }, elm2.content[0].value), ' ', elm3);
  };

  return React.createElement(React.Fragment, null, navigationGroups.map(function (group) {
    if (group.navigationGroupLink.breadcrumbTitle === 'SUPPORT' || group.navigationGroupLink.title === 'SUPPORT') {
      var navigationLinks = group.navigationLinksForGroup;
      return React.createElement(Grid, {
        item: true,
        container: true,
        alignItems: "center",
        justifyContent: "center",
        spacing: isMediumDevice ? 7 : 3,
        direction: localDirection,
        key: group.navigationGroupLink.id
      }, navigationLinks.map(function (navigationLink) {
        if (navigationLink.breadcrumbTitle === 'Accessibility' || navigationLink.breadcrumbTitle === 'Privacy Policy' || navigationLink.breadcrumbTitle === 'Terms Of Use' || navigationLink.title === 'Accessibility' || navigationLink.title === 'Privacy Policy' || navigationLink.title === 'Terms Of Use') {
          return React.createElement(Grid, {
            item: true,
            key: navigationLink.id
          }, React.createElement(TAGLink, {
            href: navigationLink.path,
            underline: "always",
            color: "neutrals.white"
          }, navigationLink.breadcrumbTitle || navigationLink.title));
        } else {
          return null;
        }
      }));
    } else {
      return null;
    }
  }), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumBook",
    color: "text.light"
  }, copyright)), React.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center"
  }, aboutDataContent.map(function (content, index) {
    return React.createElement(Grid, {
      item: true,
      textAlign: "center",
      key: "".concat(content.nodeType, " - ").concat(index)
    }, footerText(content));
  })));
};

var MottoNonSchedulingFooter = function MottoNonSchedulingFooter(props) {
  var contentfulData = props.contentfulData;
  var data = contentfulData.footer;
  var navigationGroups = data.navigationGroups;
  var contactNumber = data.contactNumber;
  var socialNetworks = data.socialNetworks;
  var footerLogo = data.logo.file.url;
  var exclusivelyAt = data.exclusivelyAt;
  var isLargeDevice = useMediaQuery('(min-width: 992px)');
  return React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: "space-between"
  }, React.createElement(Grid, {
    item: true,
    md: 3
  }, React.createElement(TAGLink, {
    href: "/"
  }, React.createElement("img", {
    src: footerLogo,
    width: isLargeDevice ? '130px' : '82px',
    height: "unset"
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumBold",
    color: "neutrals.white"
  }, "FOLLOW US")), React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 4,
    justifyContent: "center",
    alignItems: "center"
  }, socialNetworks.map(function (socialNetwork) {
    var _socialNetwork$image, _socialNetwork$image$;

    return React.createElement(Grid, {
      item: true,
      key: socialNetwork.id
    }, React.createElement(TAGLink, {
      href: socialNetwork.path,
      color: "neutrals.white"
    }, React.createElement("img", {
      src: (_socialNetwork$image = socialNetwork.image) === null || _socialNetwork$image === void 0 ? void 0 : (_socialNetwork$image$ = _socialNetwork$image.file) === null || _socialNetwork$image$ === void 0 ? void 0 : _socialNetwork$image$.url
    })));
  })))), navigationGroups.map(function (group) {
    return React.createElement(Grid, {
      item: true,
      key: group.navigationGroupLink.id
    }, React.createElement(Grid, {
      container: true,
      direction: "column",
      spacing: 3
    }, React.createElement(Grid, {
      item: true,
      key: group.navigationGroupLink.id
    }, React.createElement(TAGTypography, {
      variant: "bodyMediumBold",
      color: "neutrals.white"
    }, group.navigationGroupLink.breadcrumbTitle || group.navigationGroupLink.title)), group.navigationLinksForGroup.map(function (navigationItem) {
      return React.createElement(Grid, {
        item: true,
        key: navigationItem.id
      }, React.createElement(TAGLink, {
        href: navigationItem.path,
        color: "neutrals.white"
      }, navigationItem.breadcrumbTitle || navigationItem.title));
    })));
  }), React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumBold",
    color: "neutrals.white"
  }, "CONTACT US")), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: "tel:".concat(contactNumber),
    color: "neutrals.white"
  }, contactNumber)))), React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 3,
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumBook",
    color: "text.light"
  }, exclusivelyAt.breadcrumbTitle || exclusivelyAt.title)), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: exclusivelyAt.path
  }, React.createElement("img", {
    src: exclusivelyAt.image.file.url,
    height: "unset",
    width: isLargeDevice ? '170px' : '125px'
  })))));
};

var MottoFooter = function MottoFooter(props) {
  var contentfulData = props.contentfulData;
  var applicationName = contentfulData.name;
  return React.createElement("footer", {
    style: {
      position: 'relative',
      bottom: 0,
      left: 0,
      width: '100%',
      backgroundColor: MOTTO_COLOR.primary[500]
    }
  }, React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    spacing: 3,
    sx: {
      padding: '30px 0'
    }
  }, applicationName === 'Motto - Scheduling' ? React.createElement(MottoSchedulingFooter, {
    contentfulData: contentfulData
  }) : // This non schedling motto footer will be revisited
  React.createElement(MottoNonSchedulingFooter, {
    contentfulData: contentfulData
  }))));
};

export default MottoFooter;